import API from "../../../../../global/api";
import _ from "lodash";
import { handleNoDataVisible } from "../../../../../global/globalFunctions";
import { GenerateLOE } from "../LOE_PDF/LOE";
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import moment from "moment";


export const requestAddJob = () => {
    return {
        type: "REQUEST_ADD_JOB",
    };
};
export const successAddJob = (data) => {
    return {
        type: "SUCCESS_ADD_JOB",
        payload: data,
    };
};
export const errorAddJob = () => {
    return {
        type: "ERROR_ADD_JOB",
    };
};
export const AddJobApi = (payload, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddJob());
        API.post(`/job`, payload).then((res) => {
            GenerateLOE(res.data.data)
            dispatch(successAddJob(payload));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddJob());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetJob = () => {
    return {
        type: "REQUEST_GET_JOB",
    };
};
export const successGetJob = (data) => {
    return {
        type: "SUCCESS_GET_JOB",
        payload: data,
    };
};
export const errorGetJob = () => {
    return {
        type: "ERROR_GET_JOB",
    };
};
export const GetJobApi = () => {
    return (dispatch) => {
        dispatch(requestGetJob());
        API.get(`/job`).then((res) => {
            let getData = res.data;
            dispatch(successGetJob(getData));
        }).catch((error) => {
            dispatch(errorGetJob());
        })
    };
};


export const requestDeleteJob = () => {
    return {
        type: "REQUEST_DELETE_JOB",
    };
};
export const successDeleteJob = (user_id) => {
    return {
        type: "SUCCESS_DELETE_JOB",
        user_id: user_id,
    };
};
export const errorDeleteJob = () => {
    return {
        type: "ERROR_DELETE_JOB",
    };
};
export const DeleteJobApi = (id) => {
    return dispatch => {
        dispatch(requestDeleteJob());
        API.delete(`/job/${id}`).then(res => {
            dispatch(successDeleteJob(id))
        }).catch((error) => {
            dispatch(errorDeleteJob())
        });
    }
};


export const requestUpdateJob = () => {
    return {
        type: "REQUEST_UPDATE_JOB",
    };
};
export const successUpdateJob = (data) => {
    return {
        type: "SUCCESS_UPDATE_JOB",
        payload: data,
    };
};
export const errorUpdateJob = () => {
    return {
        type: "ERROR_UPDATE_JOB",
    };
};
export const UpdateJobApi = (data, oldData) => {
    return dispatch => {
        dispatch(requestUpdateJob());
        API.put(`/job/${oldData._id}`, {
            jobStatus: data.jobStatus,
            startDate: data.startDate,
            endDate: data.endDate,
            financialYear: data.financialYear,
            jobFee: data.jobFee,
            fee: data.fee,
            vat: data.vat,
            invoiceNumber: data.invoiceNumber,
        }, {
        }).then(res => {
            dispatch(successUpdateJob([data]))
        }).catch((error) => {
            dispatch(errorUpdateJob());
        })
    }
};


export const requestGetJobWithId = () => {
    return {
        type: "REQUEST_GET_JOB_WITH_ID",
    };
};
export const successGetJobWithId = (data) => {
    return {
        type: "SUCCESS_GET_JOB_WITH_ID",
        payload: data,
    };
};
export const errorGetJobWithId = () => {
    return {
        type: "ERROR_GET_JOB_WITH_ID",
    };
};
export const GetJobWithIdApi = (id) => {
    return (dispatch) => {
        dispatch(requestGetJobWithId());
        API.get(`/job/get-job-with-id/${id}`).then((res) => {
            let getData = res.data;
            dispatch(successGetJobWithId(getData));
        }).catch((error) => {
            dispatch(errorGetJobWithId());
        })
    };
};


export const requestAddDocumentType = () => {
    return {
        type: "REQUEST_ADD_DOCUMENT_TYPE",
    };
};
export const successAddDocumentType = (data) => {
    return {
        type: "SUCCESS_ADD_DOCUMENT_TYPE",
        payload: data,
    };
};
export const errorAddDocumentType = () => {
    return {
        type: "ERROR_ADD_DOCUMENT_TYPE",
    };
};
export const AddDocumentTypeApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddDocumentType());
        API.post(`/job/add-document-type`, data).then((res) => {
            dispatch(GetDocumentTypeApi())
            dispatch(successAddDocumentType(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddDocumentType());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetDocumentType = () => {
    return {
        type: "REQUEST_GET_DOCUMENT_TYPE",
    };
};
export const successGetDocumentType = (data) => {
    return {
        type: "SUCCESS_GET_DOCUMENT_TYPE",
        payload: data,
    };
};
export const errorGetDocumentType = () => {
    return {
        type: "ERROR_GET_DOCUMENT_TYPE",
    };
};
export const GetDocumentTypeApi = () => {
    return (dispatch) => {
        dispatch(requestGetDocumentType());
        API.get(`/job/get-document-type`).then((res) => {
            let getData = res.data;
            dispatch(successGetDocumentType(getData));
        }).catch((error) => {
            dispatch(errorGetDocumentType());
        })
    };
};


export const requestUploadDocument = () => {
    return {
        type: "REQUEST_ADD_DOCUMENT_TYPE",
    };
};
export const successUploadDocument = (data) => {
    return {
        type: "SUCCESS_ADD_DOCUMENT_TYPE",
        payload: data,
    };
};
export const errorUploadDocument = () => {
    return {
        type: "ERROR_ADD_DOCUMENT_TYPE",
    };
};
export const UploadDocumentTypeApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestUploadDocument());
        API.post(`/job/upload-document`, data).then((res) => {
            dispatch(successUploadDocument(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorUploadDocument());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestDeleteJobDocument = () => {
    return {
        type: "REQUEST_DELETE_JOB_DOCUMENT",
    };
};
export const successDeleteJobDocument = (data) => {
    return {
        type: "SUCCESS_DELETE_JOB_DOCUMENT",
        payload: data,
    };
};
export const errorDeleteJobDocument = () => {
    return {
        type: "ERROR_DELETE_JOB_DOCUMENT",
    };
};
export const DeleteJobDocumentApi = (data) => {
    return (dispatch) => {
        dispatch(requestDeleteJobDocument());
        API.post(`/job/delete-job-document`, data).then((res) => {
            dispatch(successDeleteJobDocument(data));
            // handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorDeleteJobDocument());
            // handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestUpdateJobStatus = () => {
    return {
        type: "REQUEST_UPDATE_JOB_STATUS",
    };
};
export const successUpdateJobStatus = (data) => {
    return {
        type: "SUCCESS_UPDATE_JOB_STATUS",
        payload: data,
    };
};
export const errorUpdateJobStatus = () => {
    return {
        type: "ERROR_UPDATE_JOB_STATUS",
    };
};
export const UpdateJobStatusApi = (jobId, status) => {
    console.log(jobId, status);
    return dispatch => {
        dispatch(requestUpdateJobStatus());
        API.post(`/job/update-job-status/${jobId}`, { feeStatus: status }, {
        }).then(res => {
            dispatch(successUpdateJobStatus([status]))
        }).catch((error) => {
            dispatch(errorUpdateJobStatus());
        })
    }
};


export const requestJobReport = () => {
    return {
        type: "REQUEST_JOB_REPORT",
    };
};
export const successJobReport = (data) => {
    return {
        type: "SUCCESS_JOB_REPORT",
        payload: data,
    };
};
export const errorJobReport = () => {
    return {
        type: "ERROR_JOB_REPORT",
    };
};
export const JobReportApi = (data) => {
    return dispatch => {
        dispatch(requestJobReport());
        API.post(`/job/job-report`, data, {
        }).then(res => {
            dispatch(successJobReport(res.data))
        }).catch((error) => {
            dispatch(errorJobReport());
        })
    }
};


export const requestDocumentStatusReport = () => {
    return {
        type: "REQUEST_DOCUMENT_STATUS_REPORT",
    };
};
export const successDocumentStatusReport = (data) => {
    return {
        type: "SUCCESS_DOCUMENT_STATUS_REPORT",
        payload: data,
    };
};
export const errorDocumentStatusReport = () => {
    return {
        type: "ERROR_DOCUMENT_STATUS_REPORT",
    };
};
export const DocumentStatusReportPDFApi = (payload) => {
    return (dispatch) => {
        dispatch(requestDocumentStatusReport());
        API.post(`/job/document-status-report`, payload).then((res) => {
            let getData = res.data.data;
            if (_.isEmpty(getData)) {
                handleNoDataVisible();
            } else {
                const unit = "pt";
                const size = "A4";
                const orientation = "landscape";
                const doc = new jsPDF(orientation, unit, size);
                const pageWidth = doc.internal.pageSize.getWidth();
                const title = "Document Report";
                const companyName = `${process.env.REACT_APP_COMPANY_NAME}`;
                const companyAddress = `${process.env.REACT_APP_COMPANY_ADDRESS}`;
                const companyNTN = `${process.env.REACT_APP_COMPANY_NTN}`;
                const companyPhone = `${process.env.REACT_APP_COMPANY_PHONE}`;

                // ========== HEADER ==========
                doc.setFontSize(13);
                doc.setFont("TimesNewRoman", "Normal");

                const centerText = (text, y) => {
                    const textWidth =
                        doc.getStringUnitWidth(text) *
                        doc.internal.getFontSize() /
                        doc.internal.scaleFactor;
                    const centerX = (pageWidth - textWidth) / 2;
                    doc.text(text, centerX, y);
                };

                centerText(companyName, 30);
                centerText(companyAddress, 45);
                centerText(companyPhone, 60);
                centerText(companyNTN, 75);

                doc.setFontSize(15);
                doc.setFont("TimesNewRoman", "bold");
                doc.text(title, pageWidth / 2, 100, { align: "center" });

                let currentY = 130;

                getData.forEach((job, jobIndex) => {
                    const customerName = job.customer?.companyName || "-";
                    const productName = job.product?.productName || "-";
                    const jobNo = job.sequenceNumber || "-";
                    const invoiceNo = job.invoiceNumber || "-";

                    doc.setFontSize(12);
                    doc.setFont("TimesNewRoman", "bold");
                    doc.text(`Customer: ${customerName} | Product: ${productName}`, 40, currentY);
                    doc.text(`Job No: ${jobNo} | Invoice No: ${invoiceNo}`, 40, currentY + 20);

                    currentY += 15;

                    const tableData = job.documents.map((docItem, index) => [
                        index + 1,
                        docItem.name,
                        docItem.status,
                    ]);

                    doc.autoTable({
                        head: [["Sr No", "Document Name", "Status"]],
                        body: tableData,
                        startY: currentY + 15,
                        theme: "grid",
                        styles: { font: "TimesNewRoman", fontSize: 10 },
                        headStyles: { fillColor: [41, 128, 185] },
                        alternateRowStyles: { fillColor: [240, 240, 240] },
                        margin: { left: 40, right: 40 },
                    });

                    currentY = doc.lastAutoTable.finalY + 25;
                });

                doc.setProperties({ title: `Document Report ${moment().format("DD-MM-YYYY")}`, });
                var blob = doc.output("blob");
                window.open(URL.createObjectURL(blob));

                dispatch(successDocumentStatusReport(getData));
            }
        }).catch((error) => {
            dispatch(errorDocumentStatusReport());
        });
    };
};



export const ClearJobReport = () => {
    return {
        type: "CLEAR_JOB_REPORT",
    };
};